import { Injectable } from "@angular/core";
import { LanguageService } from "./language.service";
import { EditorContentService } from "./editorcontent.service";

declare var swal: any;

//#########################################################################
//
// This service is used to store and load programs from an external server
//
//#########################################################################

@Injectable()
export class StorageService {

  private sessionDirectory = "";
  private userpassword = "";

  constructor(private la: LanguageService, private et: EditorContentService) {
  }

  // ------------------------------------
  // GETTERS AND SETTERS FOR CLASS FIELDS
  // ------------------------------------

  public getSessionDirectory() {
    return this.sessionDirectory;
  }

  public setSessionDirectory(directoryName) {
    this.sessionDirectory = directoryName;
  }

  public getUserPassword(){
    return this.userpassword;
  }

  public setUserPassword(password){
    this.userpassword = password;
  }

  //------------------------------------------------
  // PUBLIC FUNCTIONALITY USED FROM HEADER COMPONENT
  // -----------------------------------------------

  async logOut() {
    this.sessionDirectory = "";
    swal({ title: this.la.getLang()["logoutsuccess"], type: "success" });
  }

  async loadFilesOnline() {
    //check whether network connection available
    if (!navigator.onLine) {
      swal({
        title: this.la.getLang()["noconnection"],
        type: "error"
      });
      return;
    }

    //show all files available under this directory to choose
    var xmlhttp = new XMLHttpRequest();
    xmlhttp.open("GET", "https://xlogo.inf.ethz.ch/foo/readall/" + this.userpassword + "/" + this.sessionDirectory, true);
    xmlhttp.send();

    //receive response from service
    xmlhttp.onload = async function () {
      if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
        //prepare option choice where user can choose among all files
        var json = JSON.parse(xmlhttp.responseText);
        var fileArray = (<any>json).content;

        var dictOfWords = {}
        fileArray.forEach(function (entry) {
          dictOfWords[entry] = entry;
        });

        await swal({
          title: this.la.getLang()['loadprogram'],
          text: this.la.getLang()['login'] + this.sessionDirectory,
          input: 'select',
          inputOptions: dictOfWords,
          inputPlaceholder: this.la.getLang()['chooseprogram'],
          showCancelButton: true,
          inputValidator: function (value) {
            if (value === "") {
              //no file chosen. still proceeding is not possible
              return;
            }
            return new Promise(async function (reject, resolve) {
              //load file content
              var xmlhttp = await this.sendRequest("GET", "https://xlogo.inf.ethz.ch/foo/read/" + this.userpassword + "/"+ this.sessionDirectory + "/" + value.split(".lgo")[0]);
              xmlhttp.onload = function () {
                if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
                  // read random name for my data
                  var json = JSON.parse(xmlhttp.responseText);
                  var text = (<any>json).content;

                  //replace newline characters with something indepentent of OS
                  text = text.replace(/<br>/g, '\n');

                  //load contents into Editor
                  this.setEditorText(text);
                }
              }.bind(this);

              //make swal window go away
              reject();
              return;
            }.bind(this));
          }.bind(this)
        })
      }
    }.bind(this);

  }

  setEditorText(text) {
    var texts = text.split("$")
    var finalText = texts.join("\n\n")
    //delete all editors and all texts
    this.et.setTextOfCurrentEditorProgrammatically(finalText);

  }

  //anonymous method for saveFile
  async saveOnline(text) {
    //check whether network connection available
    if (!navigator.onLine) {
      swal({ title: this.la.getLang()['noconnection'], type: "error" });
      return;
    }

    //ask for filename
    var filename = "";
    while (filename === "") {
      filename = await swal({ title: this.la.getLang()['filename'], text: this.la.getLang()['login'] + this.sessionDirectory, input: 'text', inputPlaceholder: this.la.getLang()['chapterx'] });
    }

    //test whether file already exists on server
    var xmlhttp = await this.sendRequest("GET", "https://xlogo.inf.ethz.ch/foo/probe/" + this.userpassword + "/" + filename + "/" + this.sessionDirectory, null);
    xmlhttp.onload = async function () {
      if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
        // read random name for my data
        var json = JSON.parse(xmlhttp.responseText);
        var existsalready = (<any>json).exists;

        if (existsalready) {
          await swal({ title: this.la.getLang()['documentexists'], text: this.la.getLang()['overwrite'], type: "question", showCancelButton: true })
            .then(async function () {
              //continue
              //replace newline characters with something indepentent of OS
              text = text.replace(/(?:\r\n|\r|\n)/g, '<br>');

              //write to xlogo service & write file into existing directory associated to user
              var xmlhttp = await this.sendRequest("POST", "https://xlogo.inf.ethz.ch/foo/write/" + this.userpassword + "/" + filename + "/" + this.sessionDirectory, text);
              xmlhttp.onload = function () {
                if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
                  // read random name for my data
                  var json = JSON.parse(xmlhttp.responseText);
                  swal({title: this.la.getLang()['writtensuccessfully'], type: "success"});
                }
              }.bind(this);
            }.bind(this))
            .catch(async function () {
              this.saveOnline(text);
              return;
            }.bind(this));
        }else{ // filename does not yet exist on server
          //replace newline characters with something indepentent of OS
          text = text.replace(/(?:\r\n|\r|\n)/g, '<br>');

          //write to xlogo service & write file into existing directory associated to user
          var xmlhttp2 = await this.sendRequest("POST", "https://xlogo.inf.ethz.ch/foo/write/" + this.userpassword + "/" + filename + "/" + this.sessionDirectory, text);
          xmlhttp2.onload = function () {
            if (xmlhttp2.readyState == 4 && xmlhttp2.status == 200) {
              // read random name for my data
              var json = JSON.parse(xmlhttp2.responseText);
              swal({title: this.la.getLang()['writtensuccessfully'], type: "success"});
            } 
          }.bind(this);
        }

      }
    }.bind(this);
  };

  // ----------------------------------------------------------------------
  // SENDING AND RECEIVING INFORMATION TO AND FROM SERVER VIA HTTP REQUESTS
  // ----------------------------------------------------------------------

  // send GET or POST requests to server potentially with jsonified payload (for long files)
  sendRequest(requesttype, url, payload) {
    var xmlhttpContent = new XMLHttpRequest();
    xmlhttpContent.open(requesttype, url, true);
    if (requesttype === "POST") {
      xmlhttpContent.setRequestHeader("Content-Type", "application/json");
      xmlhttpContent.send(JSON.stringify({ content: payload }));
    } else {
      xmlhttpContent.send();
    }
    return xmlhttpContent;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/onlinestorage.service.ts